export default __webpack_public_path__ + "56fe96f57b9c872b9319028e7caf26e6.svg";